module.exports = __webpack_public_path__ + "static/media/fx-sign.fe4e5910.png";